export const manterSelecionadaNaLista = <T extends { id: string }>(
  atuais: T[],
  recebidas: T[],
  selecionadaId: string | null,
): T[] => {
  if (!selecionadaId || recebidas.some((item) => item.id === selecionadaId)) return recebidas;
  const aberta = atuais.find((item) => item.id === selecionadaId);
  return aberta ? [aberta, ...recebidas] : recebidas;
};

export const manterSelecionadaNaPosicao = <T extends { id: string }>(
  atuais: T[],
  recebidas: T[],
  selecionadaId: string | null,
): T[] => {
  if (!selecionadaId || recebidas.some((item) => item.id === selecionadaId)) return recebidas;
  const prevIndex = atuais.findIndex((item) => item.id === selecionadaId);
  if (prevIndex < 0) return recebidas;
  const aberta = atuais[prevIndex];
  if (!aberta) return recebidas;
  const next = [...recebidas];
  next.splice(Math.min(prevIndex, next.length), 0, aberta);
  return next;
};
